module.exports = __webpack_public_path__ + "static/media/rogue-logo.fb0998c1.png";